import { render } from "./MobileSidebar.vue?vue&type=template&id=db55d938&scoped=true"
import script from "./MobileSidebar.vue?vue&type=script&lang=js"
export * from "./MobileSidebar.vue?vue&type=script&lang=js"

import "./MobileSidebar.vue?vue&type=style&index=0&id=db55d938&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db55d938"]])

export default __exports__